import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as MailingReportService from 'services/mailing/report';

export const useMailingReportService = () => {
  const { token, tenant_id } = useSelector((store) => store.user_data);

  const fetchReports = async (options = {}) => {
    const { error, payload } = await MailingReportService.read({
      ...options,
      token
    });

    if (error) {
      return { logs: [] };
    }

    return { logs: payload.data };
  };

  const fetchCampaignAverages = async () => {
    const { error, payload } = await MailingReportService.readCampaignAverages(tenant_id, {
      token
    });
    if (error) return { avg_sent: 0, avg_open_rate: null, avg_ctor: null };
    return payload;
  };

  const fetchComparativeReport = async (options = {}) => {
    return { data: {} };
  };

  const fetchPerformanceReport = async (options = {}) => {
    return { data: {} };
  };

  const generateMonthlyReport = async ({ month, year }) => {
    const { error, payload } = await MailingReportService.readMonthly({
      query_string: `tenant_id=${tenant_id}&month=${month}&year=${year}`,
      token
    });

    if (error) {
      toast.error(error);
      return null;
    }

    return payload;
  };

  return {
    fetchReports,
    fetchCampaignAverages,
    fetchComparativeReport,
    fetchPerformanceReport,
    generateMonthlyReport
  };
};
